import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom'
import './index.css';
import App from './App';
import Random from './Random';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/random" element={<Random />} />
      </Routes>
   </Router>
  </React.StrictMode>
);

